 
<div class="content-body m-3">
    <div class="row m-3">
        <div class="col-12 text-center">
            <h4>ค้นหาข้อมูลลูกค้า</h4>
        </div>
    </div>
    <div class="row centered-content">
        <div class="col-12 col-lg-10">
                <div class="row m-3">
                <div class="col-sm-6">
                    <div class="row">
                        <div class="col-md-4 text-right">
                            <label class="required">เลขที่บัตรประชาชน/เลขประจำตัวผู้เสียภาษี</label>
                        </div>
                        <div class="col-md-8">
                            <input type="text" class="form-control"  id="dpa_contact_id" >
                        </div>
                        </div>
                </div>
                <div class="col-sm-6">
                    <div class="row">
                        <div class="col-md-2 text-right">
                        <label class="required">เลขบัญชี</label>
                    </div>
                    <div class="col-md-8">
                        <input type="text" class="form-control"  id="dpa_contact_account" >
                    </div>
                    </div>
                </div>
            </div>
            
        </div>
    </div>

    <br />
    <div class="col-12 centered-content">
        <button class="btn btn-default" (click)="CreateTable1()" >ค้นหา</button> &nbsp; 
        <button class="btn btn-clear" (click)="CancelSearch()" >ล้างข้อความ</button>
    </div>

    
    <br />ิ

    </div> 
 
<br />



// WEBPACK FOOTER //
// ./src/app/pre-req-document/pre-req-document.component.html